// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"a6227499","132":"613f034b","136":"0c02c29b","147":"972e5422","247":"24926434","267":"629b498a","416":"c3a9c2c5","482":"7ab89d12","736":"33eeb5bb","840":"a53e4d41"}[chunkId] + ".chunk.js";
};